import React, { useState, useEffect } from "react"
import { ReminderDetailDrawer } from "./reminder-detail-drawer"
import { useQueryGet } from "@/typed-client/hooks/use-query-get"

interface ReminderPageWrapperProps {
  children: React.ReactNode
  reminderId?: string | number | null
  detailOpened?: boolean
  onClose?: () => void
}

export const ReminderPageWrapper: React.FC<ReminderPageWrapperProps> = ({
  children,
  reminderId,
  detailOpened,
  onClose,
}) => {
  const [detailModalOpen, setDetailModalOpen] = useState(!!detailOpened)
  useEffect(() => {
    setDetailModalOpen(!!detailOpened)
  }, [detailOpened])

  const { data: selectedReminder } = useQueryGet(
    "/api/Reminder/GetReminderById",
    reminderId ? { reminderId: Number(reminderId) } : ({} as any),
    {
      enabled: !!detailOpened && !!reminderId,
    }
  )

  return (
    <div
      style={{
        height: "100%",
        minHeight: 0,
        display: "flex",
        flexDirection: "column",
        paddingRight: detailModalOpen
          ? "var(--reminder-drawer-width, 40rem)"
          : undefined,
        transition: "padding-right 200ms ease",
      }}
    >
      {children}
      {detailModalOpen && selectedReminder && (
        <ReminderDetailDrawer
          opened={detailModalOpen}
          onClose={() => {
            setDetailModalOpen(false)
            if (onClose) onClose()
          }}
          reminder={selectedReminder}
        />
      )}
    </div>
  )
}
